export type {
  EventTimelinePremiumPreset,
  EventTimelinePremiumPresetConfig,
  EventTimelinePremiumHourPresetConfig,
} from '@mui/x-scheduler-internals-premium/models';
export type {
  SchedulerSlots,
  SchedulerSlotProps,
  SchedulerSlotsAndSlotProps,
  EventDialogGeneralTabPropsOverrides,
  PropsFromSlot,
} from '@mui/x-scheduler/models';
export * from './slots';
